import { Component, Input } from "@angular/core";
import { IssueCardModel } from "../../../models/issue-card.model";
import { IssueStatusModel } from "../../../models/issue-status.model";

@Component({
  selector: 'app-issue-details',
  templateUrl: './issue-details.component.html',
  styleUrls: ['./issue-details.component.scss']
})

export class IssueDetailsComponent {
  @Input() issue: IssueCardModel

  public issueStatuses: IssueStatusModel[] = [
    { id: 1, title: "Регистриран", isCompleted: true },
    { id: 2, title: "Пренасочен", isCompleted: true },
    { id: 3, title: "Проверен", isCompleted: false },
    { id: 4, title: "Приключен", isCompleted: false }
  ];


  constructor() { }
  OpenFilter: Boolean = false;
  ngOnInit(): void { }
  openFilter() {
    this.OpenFilter = !this.OpenFilter;
  }


}
